  import {
    // BrowserAuthError,
    // InteractionRequiredAuthError,
    // NavigationClient,
    PublicClientApplication,
  } from '@azure/msal-browser'
  import { LogLevel } from '@azure/msal-browser'
  import global from '../../global'
  
  const scopes = [
    'User.Read',
  ]

  const config = {
  // required
    auth: {
    // must match info in dashboard
    // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
    
      clientId: global.msLogin.clientId,
    //clientId: '563642d5-7ca8-4cdd-80cd-7d6de99c9c69',
    // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
      authority: global.msLogin.authority,
    // login redirect; must match path in dashboard
      redirectUri: global.msLogin.redirectUri,
      //redirectUri: 'https://envirodatatesting2022.canadacentral.cloudapp.azure.com/Office365AuthResponse/',
      knownAuthorities: [],
    },

  // optional
    system: {
      loggerOptions: {
        logLevel: LogLevel.Verbose,
        loggerCallback,
      },
    },
  }

  function loggerCallback (level, message, containsPii) {
    if (!containsPii) {
      const parts = message.split(' : ')
      const text = parts.pop()
      switch (level) {
      case LogLevel.Error:
        return console.error(text)

      case LogLevel.Warning:
        return console.warn(text)

      case LogLevel.Info:
        return console.info(text)

      case LogLevel.Verbose:
        return console.debug(text)
      }
    }
  }

  function setAccount (account) {
    msal.setActiveAccount(account)
    return account
  }

  export function reset () {
    localStorage.clear()
  }

  const msal = new PublicClientApplication(config)

  export function msLogin() {
    const request = {
      redirectUri: config.auth.redirectUri,
      scopes,
    }

    return msal.loginPopup(request)
        .then(result => {
          // could do something with the AuthResult here if you need to
          console.log('Logged in with', result)
          localStorage.setItem('msalIdToken', result.idToken)
          localStorage.setItem('msalExpiredOn', result.expiresOn)
          // set active account
          setAccount(result.account)
          return true
        })
        .catch((error) => {
          // if we get stuck, clear session and attempt to log in again
          if (error.errorCode === 'interaction_in_progress') {
            reset()
            return msLogin()
          }
          throw(new Error(error.errorMessage))
        })
  }

  export function getActiveAzureAccount() {
    var account = msal.getActiveAccount()
    return account
  }

  export function getAzureIdToken() {
    var token = localStorage.getItem('msalIdToken')
    return token
  }

  export function isMsLoginValid() {
    if(msal == null || getAzureIdToken() == null) {
      return false
    }
    var expiredOn = localStorage.getItem('msalExpiredOn')
    if(expiredOn == null) {
      return false
    } else {
      let expiredTime = new Date(expiredOn)
      let currentTime = new Date()
      var hasExpired = currentTime >= expiredTime
      return !hasExpired
    }
  }